import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-719e03a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "appointment_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "appointment_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "appointment_title_text" }, "面談をキャンセルしました")
], -1))
const _hoisted_3 = { class: "appointment_button" }

import BaseButton from '@/components/BaseButton.vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppointmentcancelcompleteView',
  setup(__props) {

const router = useRouter();

const transitionPage = () => {
  router.push({ name: 'f00' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseButton, {
          theme: "primary",
          onClick: transitionPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("ホームへ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})